const Faq = (function () {
  let $toggleExpandItem = $(".js-toggle-expand-item");
  let $clickToToggle = $(".js-click-to-toggle");
  let $partToExpand = $(".js-part-to-expand");

  const expandedItemClass = "item-expanded";

  const isCalenderListingPage = $(".calendar-listing-page").length > 0;
  const isReportPage = $(".report-page").length > 0;
  const isFaqListingPage = $(".faq-listing-page").length > 0;
  const isFaqBlock = $(".faq-puff-block").length > 0;
  let pageUrl = "";

  function init() {
    if (isCalenderListingPage) {
      pageUrl = $(".calendar-listing-page").data("url");
      scrollDownToExpandedItem();
      addClickEventToToggle(true);
      updateClickEventWhenNewElementsAreFetched();
    } else if (isReportPage) {
      addClickEventToToggle();
    } else if (isFaqListingPage) {
      pageUrl = $(".faq-listing-page").data("url");
      scrollDownToExpandedItem();
      addClickEventToToggle(true);
    } else if (isFaqBlock) {
      addClickEventToToggle();
    }
  }

  function scrollDownToExpandedItem() {
    if ($("body").find("." + expandedItemClass).length) {
      $(function () {
        const expandedQuestion = $("body")
          .find("." + expandedItemClass)
          .first();
        const headerHeight = $("header").innerHeight();
        if (expandedQuestion && headerHeight !== undefined) {
          $("html, body").animate(
            {
              scrollTop: expandedQuestion.offset()!.top - headerHeight,
            },
            400,
          );
        }
      });
    } else {
      // If no expanded items are in listing page, remove the actionresult-part of the url:
      const pageUrlIncludingAction = window.location.pathname;
      if (pageUrl.toLowerCase() !== pageUrlIncludingAction.toLowerCase()) {
        history.replaceState(null, "", pageUrl);
      }
    }
  }

  function addClickEventToToggle(updateAdressBar = false) {
    $clickToToggle.on("click", function (el) {
      toggleAriaExpanded(el.currentTarget);

      const thisItem = $(this).closest($toggleExpandItem);
      thisItem
        .toggleClass(expandedItemClass)
        .find($partToExpand)
        .slideToggle(400);
      if (updateAdressBar) {
        updateBrowserAddressBar(thisItem);
      }
    });
  }

  function updateClickEventWhenNewElementsAreFetched() {
    const lists = document.querySelectorAll("#listing-area ul");
    if (!lists.length) return;

    lists.forEach((ul) => {
      const observer = new MutationObserver(() => {
        $(".js-click-to-toggle").off("click");
        $toggleExpandItem = $(".js-toggle-expand-item");
        $clickToToggle = $(".js-click-to-toggle");
        $partToExpand = $(".js-part-to-expand");
        addClickEventToToggle(true);
      });

      observer.observe(ul, { childList: true });
    });
  }

  function updateBrowserAddressBar(thisItem: JQuery<HTMLElement>) {
    let expandedItemToAdressBar;
    if (thisItem.hasClass(expandedItemClass)) {
      expandedItemToAdressBar = thisItem;
    } else if ($("body").find("." + expandedItemClass).length === 1) {
      expandedItemToAdressBar = $("body")
        .find("." + expandedItemClass)
        .first();
    }
    if (expandedItemToAdressBar) {
      const expandedItemUrl =
        pageUrl +
        "open" +
        "?url=" +
        expandedItemToAdressBar.data("url-segment");
      history.replaceState(null, "", expandedItemUrl);
    } else {
      history.replaceState(null, "", pageUrl);
    }
  }

  function toggleAriaExpanded(element: HTMLElement) {
    const $el = $(element);

    if ($el.is("[aria-expanded]")) {
      const expanded = $el.attr("aria-expanded") === "true";
      $el.attr("aria-expanded", expanded ? "false" : "true");
    }
  }

  return {
    init,
  };
})();

export default Faq;
